import React from 'react'

export default function ArrowBold() {
  return (
    <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_5835_11107)">
        <path d="M3.99926 7L0.535156 0.25H7.46336L3.99926 7Z" fill="#03555E" />
      </g>
      <defs>
        <clipPath id="clip0_5835_11107">
          <rect width="8" height="7" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
